import { createSelector } from '@reduxjs/toolkit';

import type { User } from '~/types/User';

import { RootState } from '~/rootState';
import { DEPRECATED_Client } from '~/types/Client';

import { api } from './createApi';

/* Stable empty result so downstream consumers can safely destructure folderTree, departmentTree` before the query resolves.*/
const EMPTY_CLIENT: DEPRECATED_Client = {
  id: null as unknown as DEPRECATED_Client['id'],
  departmentTree: [] as DEPRECATED_Client['departmentTree'],
  folderTree: {} as DEPRECATED_Client['folderTree'],
};

const selectClientId = (state: RootState) =>
  (state.currentUser as User).client ?? null;

export const selectClient = createSelector(
  [selectClientId, (state: RootState) => state],
  (clientId, state): DEPRECATED_Client => {
    if (clientId == null) {
      return EMPTY_CLIENT;
    }
    const data = api.endpoints.getClient.select(clientId)(state).data as
      | DEPRECATED_Client
      | undefined;
    return data ?? EMPTY_CLIENT;
  },
);

export const selectClientFolderTree = createSelector(
  [selectClient],
  (client) => client.folderTree,
);
